<template>
  <div class="wall-surface-area__table-wrap">
    <!-- header-row -->
    <div class="surface-area__table-header-row">
      <div class="table-headers">Orientation</div>
      <div class="table-headers">Wall surface area (%)</div>
      <div class="table-headers" style="text-align:center">Wall surface area <br /><span>(sq. M)</span></div>
    </div>
    <!-- data-rows -->
    <div v-for="(orientation, orientationIndex) in step3A.wallSurfaceAreaArrObj" :key="orientationIndex" class="data-row-wrap">
      <!-- <div class="data-field data-label">N</div> -->
      <div class="data-field">
        <div class="wall-direction">
          <span> {{ orientation.wallOrientation }}</span>
        </div>
      </div>
      <div class="data-field input-wall-surface-area">
        <v-text-field type="number" v-model="orientation.orientationSurfaceArea" dense outlined placeholder="Enter " suffix="%"></v-text-field>

        <!-- <lv-input type="number" v-model="orientation.orientationSurfaceArea" outlined placeholder="Enter ">
          <template #append>% </template>
        </lv-input> -->
      </div>
      <div class="data-field">
        <!-- <lv-input type="number" disabled outlined placeholder="0.00" v-model="orientation.calcWallArea" /> -->
        {{ orientation.calcWallArea }}
      </div>
    </div>
    <!-- <hr/> -->
    <hr />
    <div class="step3A__window-type-note">
      <v-alert text dense color="teal" icon="mdi-alert-circle" border="left">
        Note: Summation of percentage input of all directions should add to 100%
      </v-alert>
    </div>
  </div>
</template>

<script>
import LvInput from 'lightvue/input';
export default {
  components: {
    LvInput,
  },
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    step2: {
      get: function() {
        return this.$store.state.schema.inputs.step2;
      },
      set: function(step2) {
        this.$store.dispatch('setStep2', step2);
      },
    },
    step3A: {
      get: function() {
        return this.$store.state.schema.inputs.step3A;
      },
      set: function(step3A) {
        this.$store.dispatch('setStep3A', step3A);
      },
    },
    calcWallSurfaceArea() {},
  },
  data() {
    return {
      // fenestration_steps:['Wall Surface Area']
    };
  },
  // beforeUpdate() {
  //   this.calculateWallArea();
  // },
  watch: {
    step3A: {
      handler: function() {
        this.calculateWallArea();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    calculateWallArea() {
      let tp = 0;
      // console.log('Watcher');
      this.step3A.wallSurfaceAreaArrObj.forEach(wall => {
        wall.calcWallArea = +(+this.step2.summary_step2.surface_area_wall * 0.01 * +wall.orientationSurfaceArea).toFixed(2);
        // console.log('calcWallArea', wall.calcWallArea);
        tp = +tp + +wall.orientationSurfaceArea;
      });
      this.$emit('calculateTotal', tp);
    },
  },
};
</script>

<style lang="scss">
.surface-area__table-header-row {
  display: flex;
  width: 100%;
  background-color: #dedede;
  border-radius: 4px;
  .table-headers {
    color: #343f4b;
    padding: 12px;
    font-size: 16px;
    width: 33.33%;
  }
}
.data-row-wrap {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 8px 12px 4px 12px;
  //   align-items: center;
  .data-field {
    width: 25%;

    .wall-direction {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    // text-align: center;
  }
}
.input-wall-surface-area {
  .lv-input__field {
    .lv-input__append {
      padding: 8px;
      margin-left: -124px;
    }
  }
}
.step3A__window-type-note {
  // background-color: #b3f5db;

  // font-style: italic;
  padding: 4px 2px 4px 2px;
  margin: 12px 0px;
}
</style>
